// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "The link to your Airbnb ad is required",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "The Airbnb rating must be at least 4 to 5",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Create account check your email to activate your access to the club",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Club reserved for airbnb guests not s'4 5",
  comparez_vos_gains_r_els: "Compare your actual earnings",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "The traveltrok mod is a winner, the traveler wins",
  votre_prix_sur_les_autres_sites: "Your price on other sites",
  diminuer_le_prix: "Reduce the price",
  augmenter_le_prix: "Increase the price",
  net_pour_vous: "Net for you",
  de_commissions: "Commissions",
  prix_pay__par_le_voyageur: "Price paid by the traveler",
  revenu___d_clarer__imp_ts_: "Income to declare taxes",
  vous_d_clarez_100__du_prix____commissions__:
    "You declare 100 of the price commissions",
  de_frais_h_te: "Host fees",
  __0__compar____booking_: "0 comparison booking",
  mod_le_frais_h_te__depuis_25_____: "Mod the host fee since 25",
  vous_d_clarez_100__du_prix_voyageur_:
    "You declare 100 of the passenger price",
  strat_gie_gagnante: "Winning strategy",
  prix_voyageur: "Traveler price",
  _5__pour_le_voyageur: "5 for the traveler",
  le_meilleur_des_deux_mondes: "The best of both worlds",
  avantage_fiscal: "Tax advantage",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "You declare less you pay less taxes",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok applies 5 traveler fees",
  appartement: "Apartment",
  maison: "Home",
  inclut_villa_chalet: "Includes chalet villa",
  loft: "Loft",
  luxe: "Luxury",
  insolite: "Unusual",
  autre: "Other",
  campagne: "Campaign",
  mer: "Sea",
  montagne: "Mountain",
  au_dessus_de_500_nuit: "Above €500/night",
  aucun_resultat_dynamique: "No dynamic results",
  service_de_localisation_indisponible__r_essayez_da:
    "Location service unavailable, try again in a moment",
  quel_type_de_logement_souhaitez_vou:
    "What type of accommodation do you want to offer?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Choose the category that best describes your accommodation",
  quel_est_le_cadre_du_logement__: "What is the housing environment like?",
  o__est_situ__votre_logement__: "Where is your accommodation located?",
  pays_europ_en_de_r_f_rence: "European country of reference",
  ville__village__code_postal___: "City, village, postal code...",
  recherche_en_cours___: "Research in progress...",
  recherche___: "Research...",
  localiser: "Locate",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "We will use this address to locate your accommodation",
  localis_: "Localized",
  _copy__openstreetmap_france: "© OpenStreetMap France",
  emplacement_valid_: "Validated location",
  d_crivez_votre_logement: "Describe your accommodation",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Make travelers want to stay with you",
  titre_de_l__annonce: "Ad title",
  ex__charmant_studio_au_c_ur_de_paris:
    "Ex: Charming studio in the heart of Paris",
  soyez_concis_et_accrocheur: "Be concise and catchy",
  description_d_taill_e: "Detailed description",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Talk about your accommodation, the neighborhood, the amenities...",
  mentionnez_les_points_forts: "Mention the strong points",
  voyageurs: "Travelers",
  chambres: "Rooms",
  lits: "Beds",
  salles_de_bain: "Bathrooms",
  d_tails_du_logement: "Accommodation details",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Give more information on reception capacity",
  surface__m__: "Area (m²)",
  ex__85: "Ex: 85",
  ajoutez_des_photos: "Add photos",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Highlight your home with beautiful images",
  glissez_vos_photos_ici: "Drag your photos here",
  parcourez_vos_fichiers: "Browse your files",
  jpg__png_jusqu____5_mo: "JPG, PNG (up to 5 MB)",
  d_j__en_ligne: "Already online",
  __uploader: "To upload",
  fixez_votre_prix: "Set your price",
  vous_pourrez_le_modifier___tout_moment_: "You can modify it at any time",
  par_nuit: "Per night",
  aper_u_de_votre_annonce: "Preview your ad",
  titre_de_votre_annonce: "Title of your ad",
  nouveau: "New",
  localisation: "Location",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Deleting the profile type delete then confirm if complete deletion is impossible your profile will be paused and hidden",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Complete Delete Unavailable Profile Paused and Hide",
  preferences: "Preferences",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Manage your units, your visibility and the status of your profile",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "You remain connected but your ads are no longer active in the suggestions",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Your profile and your accommodations no longer appear on the map and destination pages",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Database not migrated your preferences are saved locally for now",
  delai_depasse: "Deadline exceeds",
  echeance_aujourd__hui: "Due today",
  mois_restants: "Remaining months",
  nuits_dues_et_aucun_accueil_effectue:
    "Nights due and no reception carried out",
  suivi_des_echanges: "Monitoring of exchanges",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Track the nights owed both ways who owes you nights who you owe and the time remaining to close each exchange",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Name accommodation contract dates status of both sides and remaining time",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualize your target cities and search radii around each point",
  __d_couvrir___: "to cover",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "The essential places to visit during your stay",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Unable to finalize the request try again in",
  r_server_ton_s_jour___: "book your stay",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Simple 3-step search for details v",
  recherche: "Research",
  validation: "Validation",
  demande_envoy_e: "Request sent",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "A host will respond quickly with details",
  cr_er_une_nouvelle_demande: "create a new request",
  "1__ton_s_jour": "1 day",
  arriv_e: "Arrival",
  pers_: "People",
  dates_flexibles: "Flexible dates",
  dates_exactes: "Exact dates",
  _3_jours: "3 days",
  _7_jours: "7 days",
  _14_jours: "14 days",
  je_voyage_avec_des_animaux: "I travel with animals",
  "2__infos_r_servation": "2 reservation information",
  nom_complet: "Full name",
  ex__clara_martin: "ex clara martin",
  message___l_h_te: "Message the host",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "Quick presentation arrival time needs part",
  "3__validation_de_la_r_servation": "3 validation of the reservation",
  destination: "Destination",
  s_jour: "stay",
  flexibilit_: "Flexibility",
  tarification_traveltrok: "traveltrok pricing",
  frais_plateforme: "Platform fees",
  "1eur_voyageur___1eur_h_te": "1their traveler 1their host",
  incluse: "Included",
  total_estim_: "Total estimate",
  continuer: "Continue",
  envoi___: "Sending",
  confirmer_ma_r_servation: "Confirm my reservation",
  r_sum__intelligent: "R sum smart",
  prix_base: "Base price",
  total_actuel: "Current total",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Includes 1 guest and 1 guest per night assuran",
  membres_actifs: "Active members",
  note_moyenne: "Average rating",
  d_couvrez_: "discover",
  points_forts: "Highlights",
  conseils_pratiques: "Practical advice",
  informations_pratiques: "Practical information",
  meilleure_saison: "Best season",
  s_jour_moyen: "average stay",
  langue: "Language",
  monnaie: "Cash",
  fuseau_horaire: "Time zone",
  voir_les_logements: "See the accommodations",
  nous_contacter: "Contact us",
  villa: "Villa",
  logements_disponibles___: "Accommodations available",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Overnight listings with verified hosts",
  voir_la_carte_des_logements: "See the accommodation map",
  h_te_v_rifi_: "verified host",
  mod_le_traveltrok: "Mod the traveltrok",
  r_server: "to book",
  pas_encore_de_logements_ici: "No accommodation here yet",
  sois_le_premier_h_te___proposer_son_logement___:
    "Be the first host to offer their accommodation",
  ajouter_mon_logement: "Add my accommodation",
  destinations_proches: "Nearby destinations",
  explorez_d_autres_destinations_en_: "Explore other destinations in",
  am_rique_du_nord: "North America",
  am_rique_du_sud: "South America",
  oc_anie: "Oceania",
  afrique: "Africa",
  asie: "Asia",
  europe: "Europe",
  carte_des_destinations: "Destination map",
  destinations_affich_es: "Displayed destinations",
  continents: "Continents",
  survolez_un_point_pour_voir_les_d_tails: "Hover over a point to see details",
  _changes_r_alis_s: "changes made",
  mes_favoris: "My favorites",
  sauvegard_: "Backup",
  tout_effacer: "Clear all",
  s_lectionn_: "Selection",
  pour_comparaison: "For comparison",
  voir_la_comparaison: "See the comparison",
  trier_par__: "sort by",
  note: "Note",
  _changes: "changes",
  capacit_: "Capacity",
  pi_ces: "Pieces",
  type_de_logement: "Type of accommodation",
  effacer: "To erase",
  r_initialiser_les_filtres: "R initialize filters",
  filtres_actifs__: "Active filters",
  aucun_r_sultat: "No results",
  aucun_favori_ne_correspond___vos_filtres_: "No favorites match your filters",
  comparaison_des_logements: "Accommodation comparison",
  logements_s_lectionn_s: "Selected accommodations",
  fermer: "Close",
  astuce: "Trick",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Use the filters to refine your favorites by",
  type: "Kind",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Then select up to 4 slots for the",
  aucun_sch_ma_conversation_compatible_trouv__:
    "No sch my compatible conversation found",
  souhaite_venir_dynamique: "Wish to come dynamic",
  aimerais_visiter_dynamique: "Would like to visit dynamic",
  demande_ignor_e_: "Request ignored",
  conversation_introuvable_: "Conversation not found",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Unable to open discussion at the moment",
  demande_supprim_e_: "Request deleted",
  bonjour_merci_dynamique: "Hello thank you dynamic",
  demande_supprim_e_avec_un_message_poli_:
    "Request deleted with a polite message",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Unable to delete this request at this time",
  demandes_directes: "Direct requests",
  matching_auto: "They want to come to your area",
  match_r_ciproque: "Reciprocal match",
  carte_secteur: "Sector card",
  toutes: "All",
  lik_es: "Liked",
  en_discussion: "Under discussion",
  ignor_es: "Ignored",
  sans_date_pr_cise__juste__change_: "Without specific date just exchange",
  date_pr_cise___dans_les_6_mois: "Specific date within 6 months",
  date_pr_cise___dans_l_ann_e: "Specific date in the year",
  flexible: "Flexible",
  date_pr_cise: "Specific date",
  dates_identiques: "Same dates",
  dates_compatibles: "Compatible dates",
  dates_diff_rentes: "Different dates",
  dates_inconnues: "Dates unknown",
  souhaite_venir__: "Wish to come",
  voir_le_logement_cibl_: "View target accommodation",
  personnes_int_ress_es_par_votre_secteur: "People interested in your sector",
  vert___match_r_ciproque_ville___dates: "Green reciprocal match city dates",
  int_r_t_entrant: "Incoming interest",
  logement_cibl___: "Targeted housing",
  dates__: "Dates",
  sans_date_pr_cise: "Without specific date",
  ouvrir_le_chat: "Open chat",
  pas_encore_de_points_sur_la_carte: "No points on the map yet",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Members who want to come to your area to",
  logement_vis_: "Targeted accommodation",
  demande: "Request",
  message: "Message",
  logement_s_: "accommodation(s)",
  annonce_indisponible: "Announcement unavailable",
  jour_s_: "days)",
  dur_e___d_finir: "Duration to finish",
  match_auto: "Auto match",
  r_ciproque: "Reciprocal",
  discuter_dans_la_messagerie: "Chat in messaging",
  ignorer_la_demande: "Ignore the request",
  ignorer: "Ignore",
  supprimer_avec_message_poli: "Delete with polite message",
  poli: "Polite",
  supprimer_sans_message: "Delete without message",
  suppr_: "Delete",
  aucune_demande_pour_le_moment: "No requests at the moment",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "The board is ready and requests will appear here",
  surface: "Surface",
  voyagez: "Travel",
  envie_d___changer_avec_: "Want to change with",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Propose a housing exchange and cover",
  gratuitement_: "Free",
  voir_la_fiche_du_logement: "See the accommodation sheet",
  carte_des_logements: "Housing map",
  r_sultats_visibles: "visible results",
  jour: "Day",
  s_lectionn_s: "selected s",
  printemps: "Spring",
  _t_: "t",
  automne: "Autumn",
  hiver: "Winter",
  toute_l__ann_e: "All year round",
  bonjour_host_dynamic: "Hello host dynamic",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Unable to contact this host errormessage",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Unable to contact this host at the moment",
  annonce_introuvable_: "Ad not found",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Choose your dates to send the proposal",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "The departure date must be later than the arrival date",
  proposition_d__change_avec_dates_pr_cises:
    "Exchange proposal with specific dates",
  __logement_cibl_: "Targeted Housing",
  __ville: "City",
  __arriv_e_souhait_e: "Desired arrival",
  __d_part_souhait_: "Desired departure",
  __dur_e: "Duration",
  nuit_s_: "Night(s)",
  __voyageurs: "Travelers",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "I am open to negotiation if necessary.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Indicate a valid number of nights for the proposal",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Flexible exchange proposal without fixed dates",
  __je_propose: "I propose",
  __je_demande: "I ask",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "We then validate the dates together according to our availability.",
  indiquez_un_nombre_de_nuits_valide_: "Enter a valid number of nights",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Exchange proposal any time during the year",
  __dur_e_souhait_e: "Desired duration",
  __p_riode_pr_f_r_e: "Preferred period",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "I am flexible on exact dates and willing to talk about it.",
  proposition_invalide_: "Invalid proposal",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Proposal sent, discussion opened...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Unable to send your proposal",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Unable to send your proposal at the moment",
  logement_introuvable: "Accommodation not found",
  retour_aux_logements: "Return to accommodation",
  annonce_airbnb: "Airbnb ad",
  lien_airbnb_verification_helper:
    "This link allows us to verify that you are the manager of the ad.",
  aucune_photo_disponible: "No photos available",
  logement_propos__par: "Accommodation offered by",
  __propos_de_ce_logement: "About this accommodation",
  aucune_description_fournie_: "No description provided",
  ce_que_propose_ce_logement: "What this accommodation offers",
  description_du_logement: "Description of accommodation",
  aucun__quipement_sp_cifi__: "No specified equipment",
  _change_entre_h_tes: "exchange between hosts",
  votre_proposition_d__change: "Your exchange proposal",
  quand_vous_voulez: "When you want",
  je_propose: "I propose",
  nuits_chez_moi: "Nights at my place",
  je_demande: "I ask",
  nuits_chez_vous: "Nights at your place",
  nombre_de_nuits: "Number of nights",
  p_riode_pr_f_r_e: "Preferred period",
  message__optionnel_: "Optional message",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Ex we are flexible we can adapt to your",
  entrer_en_n_gociation: "Enter into negotiation",
  envoyer_ma_proposition: "Send my proposal",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "You can offer an exchange with or without dates",
  informations_l_gales: "Legal information",
  conditions_d____utilisation: "Terms of use",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "By using traveltrok you agree to use",
  les__changes_se_font_directement_entre_membres__:
    "Exchanges are made directly between members",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL may suspend an account in the event of co",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "By joining DONKEY TRAVEL, you accept these commitments. Trust is built on simple actions.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "A solid charter in line with the best practices of other famous companies.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Withdrawal from the club following repetition or serious misconduct.",
  exclusion_d_finitive: "Permanent exclusion",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Restricted account awaiting facts.",
  suspension_temporaire: "Temporary suspension",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Reminder of the rules and correction required.",
  avertissement_officiel: "Official warning",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "The club protects reliable guests. Serious breaches result in action.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Any cancellation must be documented in messaging and processed by support.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "We do not cancel an exchange without valid reason. In the event of force majeure (disaster, serious illness, legal impossibility), a postponement must be proposed as quickly as possible.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "I communicate quickly in case of doubt or change.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "I welcome someone who does the same job as a host.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "I provide a warm and professional welcome.",
  relation_entre_h_tes: "Relationship between hosts",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Any cleaning fees are announced and validated before the exchange.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "Access and operating information is clear.",
  linge_et_pr_paration: "Laundry and preparation",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "The level of service remains the same, even in a free exchange.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "The accommodation is clean and ready to live in upon arrival.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "I prepare the accommodation as for an Airbnb client.",
  qualit__d_accueil__quivalente: "Equivalent quality of reception",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "I respect the calm, the neighbors and the neighborhood.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "No parties, events or unauthorized invitations allowed in the accommodation.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "I respect the host's internal regulations.",
  vie_de_quartier_et_r_gles: "Neighborhood life and rules",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "When dates are blocked, I commit to coming.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "I don't lie about the usual price value of my accommodation.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "I do not lie on my profile, my history or my accommodation.",
  honn_tet__et_fiabilit_: "Honesty and reliability",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "I respect the materials, equipment and departure instructions.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "I store used linen (e.g. sheets in a ball) in the indicated place, to limit cleaning costs.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "I make the accommodation as clean as I found it.",
  respect_total_du_logement: "Total respect for housing",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL is a serious host club; a good rating implies exemplary conduct, both as a traveler and as a host.",
  "howItWorks.cta.explore": "Explore destinations",
  "howItWorks.cta.signup": "See our offers",
  "howItWorks.cta.subtitle":
    "Start by renting your own place. Then activate exchange if you want to exchange between hosts.",
  "howItWorks.cta.title": "Ready to launch your rentals?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Publish your accommodation, validate your profile and start receiving exchange offers.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "View the density of housing already registered in the club. The points remain anonymous (no address, no details, just network dynamics).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Take a step back to avoid burnout from continuous hosting.",
  _an: "/ year",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL connects guests around the world for authentic and affordable stays.",
  ____100__made_in_france__picardie_: "🇫🇷 100% Made in France (Picardie)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Not Silicon Valley, but the Haute-Somme valley.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Exchanges across Europe between Airbnb hosts rated 4.5+. 2026 launch offer: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "After months of hosting, transform your slow periods into real breathing space without blowing your budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Take a step back to avoid burnout from continuous hosting.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Welcome guests who already know the requirements of the field, then share your methods and feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Travel at reduced cost thanks to exchanges between club members.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "When your local quota is reached, you can trade off-platform subject to local compliance.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL is a European revolution: an exchange platform for guests who already pay for heating, taxes, electricity, internet and maintenance, and welcome all year round like in a hotel. Here, you interact with hosts who know how to welcome you, you share your experiences, then you go and discover another place without breaking the bank.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Our model is based solely on subscriptions, not on the exploitation of data.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Ad-free. Without resale of data. 100% member-funded.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "The club is not legal advice; each member must respect local rules (declarations, quotas, co-ownership, taxation, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "A European exchange platform reserved for Airbnb hosts",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Private club for guests rated 4.5+: a unique subscription to exchange throughout Europe.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Reserved for Airbnb hosts with a rating greater than or equal to 4.5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "50% reduction in 2026: 25EUR/year instead of 50EUR/year. Price guaranteed for life for the first 1000 registrations.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Low season, breaks, meetings between guests, holiday savings: everything is designed for active guests in Europe.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Welcome members and be welcomed back. A simple, direct and cashless exchange between owners.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'\"We exchanged our house in Lyon for a villa in Corsica. Cost: €0.\"'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "No coins, no points. Just an agreement between two owners. I come to your house, you come to my house.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "You find a member you like and agree to exchange accommodations.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "No points to count. Just the pleasure of sharing and meeting.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "More than an economy, it's a new way of traveling.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Exchanges are completely free. No service fees, no cleaning fees (unless specifically agreed).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Only verified hosts can trade. You are welcoming someone who knows the value of a home.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Forget the value of points. A night is a night. The exchange is based on trust between hosts.",
  __an: "/ year",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Exchanges across Europe between Airbnb hosts rated 4.5+. 2026 launch offer: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "After months of hosting, transform your slow periods into real breathing space without blowing your budget.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Take a step back to avoid burnout from continuous hosting.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Welcome guests who already know the requirements of the field, then share your methods and feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Travel at reduced cost thanks to exchanges between club members.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "When your local quota is reached, you can trade off-platform subject to local compliance.",
  la_r_volution_des_h_tes_en_europe: "The host revolution in Europe",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Finally a break for Airbnb hosts rated 4.5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL is a European revolution: an exchange platform for guests who already pay for heating, taxes, electricity, internet and maintenance, and welcome all year round like in a hotel. Here, you interact with hosts who know how to welcome you, you share your experiences, then you go and discover another place without breaking the bank.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Price guaranteed for life for the first 1000 registrations.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "At DONKEY TRAVEL, your data is not a product.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "We never sell our members' information.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "We do not share any data with third parties for commercial purposes.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "The site is secure and your exchanges remain private.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL is guaranteed advertising-free: you are the member, not the product.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Our model is based solely on subscriptions, not on the exploitation of data.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Ad-free. Without resale of data. 100% member-funded.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "The club is not legal advice; each member must respect local rules (declarations, quotas, co-ownership, taxation, etc.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "A European exchange platform reserved for Airbnb hosts",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Private club for guests rated 4.5+: a unique subscription to exchange throughout Europe.",
  acc_s_r_serv_: "Reserved access",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Reserved for Airbnb hosts with a rating greater than or equal to 4.5.",
  europe_unique: "Single Europe",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/year to exchange throughout Europe.",
  lancement_2026: "Launch 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "50% reduction in 2026: 25EUR/year instead of 50EUR/year. Price guaranteed for life for the first 1000 registrations.",
  club_d__change_h_tes_airbnb: "Airbnb Host Exchange Club",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Optimize your off-peak periods thanks to exchanges",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Low season, breaks, meetings between guests, holiday savings: everything is designed for active guests in Europe.",
  r_serv__aux_h_tes_traveltrok: "Reserved for DONKEY TRAVEL guests",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Travel for free with your accommodation",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Welcome members and be welcomed back. A simple, direct and cashless exchange between owners.",
  devenir_h_te: "Become a host",
  comment__a_marche__: "How does it work?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'\"We exchanged our house in Lyon for a villa in Corsica. Cost: €0.\"'",
  amis_partageant_un_repas_en_corse: "Friends sharing a meal in Corsica",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, members since 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "No need to exchange on the same dates: you come to my house in June, I come to your house in September!",
  l__change_direct___simple_et_humain: "Direct exchange: simple and human",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "No coins, no points. Just an agreement between two owners. I come to your house, you come to my house.",
  "1__accord_mutuel": "1. Mutual agreement",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "You find a member you like and agree to exchange accommodations.",
  "2__flexibilit__totale": "2. Total flexibility",
  "3__z_ro_comptabilit_": "3. Zero accounting",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "No points to count. Just the pleasure of sharing and meeting.",
  pourquoi_les_h_tes_adorent_ce_syst_me__: "Why do hosts love this system?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "More than an economy, it's a new way of traveling.",
  "0__de_frais": "0€ fees",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Exchanges are completely free. No service fees, no cleaning fees (unless specifically agreed).",
  confiance_totale: "Total confidence",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Only verified hosts can trade. You are welcoming someone who knows the value of a home.",
  simplicit_: "Simplicity",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Forget the value of points. A night is a night. The exchange is based on trust between hosts.",
  rejoignez_la_communaut__des_h_tes: "Join the host community",
  rejoignez_la_communaut__et_commencez____changer_:
    "Join the community and start chatting.",
  commencer_maintenant: "Start now",
  chargement___: "Loading...",
  accueil: "Welcome",
  comment_a_marche: "How it works",
  vos_engagements: "Your commitments",
  pays: "Country",
  logements: "Housing",
  _change_h_te: "Host Exchange",
  devenir_membre: "Become a member",
  se_d_connecter: "Log out",
  mon_espace: "My space",
  connexion: "Connection",
  connect_: "Connected",
  visuel_en_cours_de_g_n_ration_ai___: "Visual being generated AI...",
  tableau_de_bord: "Dashboard",
  mes_annonces: "My ads",
  o__je_veux_aller: "Where I want to go",
  qui_veut_venir_chez_moi: "Smart matching",
  destinations: "Destinations",
  carte_des_membres: "Members card",
  calendrier: "Calendar",
  votre_coffre: "Your safe",
  favoris: "Favorites",
  messages: "Messages",
  mon_profil: "My profile",
  pr_f_rences: "Preferences",
  profil: "Profile",
  h_te: "Host",
  membre_fondateur: "Founding Member",
  membre: "Member",
  r_duire__tendre: "Reduce/expand",
  r_duire_le_menu: "Collapse menu",
  cette_page_n_a_pas__t__g_n_r_e: "This page was not generated",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Give me more details about this page so I can generate it",
  connexion_en_cours___: "Connection in progress...",
  email_ou_mot_de_passe_incorrect: "Incorrect email or password",
  une_erreur_est_survenue: "An error has occurred",
  erreur_de_connexion_google: "Google connection error",
  connecte_toi_pour_retrouver_ta_communaut_: "Log in to find your community",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Join the DONKEY TRAVEL host community",
  inscription: "Registration",
  continuer_avec_google: "Continue with Google",
  ou: "Or",
  ton_pr_nom_et_nom: "Your first and last name",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Link to your Airbnb listing",
  veuillez_saisir_un_lien_airbnb_valide: "Please provide a valid Airbnb link",
  lien_calendrier_ical: "iCal link to your Airbnb calendar (Optional for now)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel never changes your Airbnb calendar. We just read it to show your availability. You will need to continue to manually block your redemption dates on Airbnb to avoid double bookings.",
  note_airbnb: "Airbnb rating",
  abonnement: "Subscription",
  europe_unique___50eur_an: "Single Europe - 50EUR/year",
  offre_lancement_2026__25eur_an___50__: "Launch offer 2026: 25EUR/year (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Price guaranteed for life for the first 1000 registrations.",
  mot_de_passe: "Password",
  "8_caract_res_minimum": "8 characters minimum",
  connexion___: "Connection...",
  cr_ation_du_compte___: "Creating the account...",
  se_connecter: "Log in",
  cr_er_mon_compte: "Create my account",
  mot_de_passe_oubli___: "Forgotten password?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "By creating an account, you agree to our",
  cgu: "CGU",
  _et_notre_: "and our",
  politique_de_confidentialit_: "Privacy Policy",
  r_servation_de_logements: "Accommodation reservation",
  support_h_te_prioritaire: "Priority Host Support",
  carte___filtres_avanc_s: "Map + advanced filters",
  flux_de_r_servation__tape_par__tape: "Step-by-step booking flow",
  couverture_dommages_assistance: "Damage/assistance coverage",
  multi_logements___reporting: "Multi-housing + reporting",
  comparatif_des_modes: "Comparison of modes",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "What you activate according to your TRAVELTROK usage.",
  fonction: "Function",
  voyageur: "Traveler",
  pro: "Pro",
  abonnement_europe_unique: "Single Europe subscription",
  rejoindre_le_club_europe: "Join the Europe club",
  basse_saison: "Low season",
  pause: "Take a break",
  rencontres: "Meet Hosts",
  _conomies: "Savings",
  quota_atteint: "Quota reached",
  _ligibilit_: "Eligibility",
  zone_d__change: "Exchange area",
  toute_l_europe: "All of Europe",
  mod_le: "Model",
  abonnement_unique_annuel: "Single annual subscription",
  propri_taire_europ_en_en_pause: "European owner on break",
  v_rification: "Verification",
  h_tes_certifi_s: "Certified Hosts",
  abonnement_unique_traveltrok: "Single subscription DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Launch offer 2026: 25EUR/year instead of 50EUR/year",
  pourquoi_ce_club_fonctionne_pour_les_h_tes: "Why this club works for hosts",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "At DONKEY TRAVEL, your data is not a product.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "We never sell our members' information.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "We do not share any data with third parties for commercial purposes.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "The site is secure and your exchanges remain private.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL is guaranteed advertising-free: you are the member, not the product.",
  rejoindre_le_club: "Join the club",
  trouver_un_h_te: "Find a host",
  proposer_un__change: "Suggest an exchange",
  synchronisation_mise___jour_avec_succ_s: "Sync updated successfully",
  erreur_lors_de_la_mise___jour: "Error during update",
  indisponible: "Unavailable",
  r_serv_: "Reserve",
  erreur_chargement: "Loading error",
  inconnue: "Unknown",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Unable to recover iCal calendar. Check the iCal Airbnb URL and try again.",
  r_servation: "Reservation",
  _v_nements_synchronis_s: "synchronized events",
  _v_nements_import_s: "imported events",
  erreur_sync: "Sync error",
  _chec_de_synchronisation: "Synchronization failure",
  dates_bloqu_es_avec_succ_s: "Dates blocked successfully",
  erreur_blocage: "Blocking error",
  mois: "Month",
  aujourd_hui: "Today",
  d_tails: "Details",
  actions: "Actions",
  bloquer: "To block",
  filtres: "Filters",
  confirm_: "Confirmed",
  en_attente: "On hold",
  proposition: "Proposal",
  bloqu_: "Blocked",
  synchronisation: "Synchronization",
  configurer: "Configure",
  airbnb_connect_: "Airbnb connected",
  derni_re_synchro_r_ussie: "Last successful sync",
  derni_re_synchro_en__chec: "Last failed sync",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Connected calendar. Start a sync to import your Airbnb reservations.",
  synchro___: "Sync...",
  forcer_la_synchro: "Force sync",
  non_synchronis_: "Not synchronized",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Connect your Airbnb calendar to avoid double bookings!",
  bloquer_des_dates: "Block dates",
  s_lection: "Selection",
  jours: "days",
  raison__optionnel__ex__travaux_: "Reason (optional, e.g.: Works)",
  annuler: "Cancel",
  confirmer: "Confirm",
  synchronisation_airbnb: "Airbnb synchronization",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Add your Airbnb links to automatically sync your reservations and avoid duplicates.",
  lien_de_l_annonce_airbnb: "Airbnb ad link",
  airbnb_ical_calendar_link: "Airbnb iCal calendar link",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Available in Announcement Settings Calendar Export",
  enregistrer: "Save",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Please click 'Locate' to validate the address before continuing.",
  vous_devez__tre_connect__pour_publier_: "You must be logged in to post.",
  id_manquant_apr_s_sauvegarde: "ID missing after backup",
  erreur_upload_photo: "Photo upload error",
  erreur_sauvegarde_metadata_photos: "Error saving metadata photos",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "An error occurred while saving",
  quitter: "To leave",
  modification: "Edit",
  cr_ation: "Creation",
  _tape: "Stage",
  sur: "on",
  sauvegarde_en_cours___: "Backup in progress...",
  retour: "Back",
  sauvegarde___: "Backup...",
  mettre___jour: "To update",
  publier_l_annonce: "Publish the ad",
  suivant: "Following",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Are you sure you want to remove this ad?",
  impossible_de_supprimer_l_annonce__: "Unable to delete ad:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Manage your accommodations and their availability.",
  ajouter_une_annonce: "Add an ad",
  vous_n_avez_aucune_annonce: "You have no ads",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Start earning income by renting out your home. It's quick and easy.",
  cr_er_ma_premi_re_annonce: "Create my first ad",
  publi_: "Published",
  brouillon: "Draft",
  __nuit: "/ night",
  voir_l_annonce: "See the ad",
  modifier: "To modify",
  supprimer: "DELETE",
  quels__quipements_proposez_vous__: "What equipment do you offer?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Select everything that is available to travelers.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "No compatible conversation diagram found.",
  logements_concern_s: "housing concerned",
  logement_non_pr_cis_: "Accommodation not specified",
  erreur_lors_de_l_envoi_du_message_: "Error sending message.",
  rechercher_une_conversation: "Search for a conversation",
  demandes_re_ues: "Requests received",
  mes_demandes: "My requests",
  aucune_demande_re_ue_: "No requests received.",
  aucune_demande_envoy_e_: "No request sent.",
  photo_de_profil: "Profile picture",
  localisation_non_pr_cis_e: "Location not specified",
  listing_: "Listing:",
  en_ligne: "Online",
  vous: "YOU",
  _crivez_votre_message___: "Write your message...",
  s_lectionnez_une_conversation: "Select a conversation",
  pour_commencer___changer: "to start trading",
  logement_propos_: "Proposed accommodation",
  description_non_pr_cis_e: "Description not specified",
  ch_: "ch.",
  voy_: "see.",
  nuit: "night",
  prix_non_pr_cis_: "Price not specified",
  voir: "See",
  aucune_annonce_li_e___cette_conversation_:
    "No announcements related to this conversation.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Select a conversation to see details.",
  bonjour: "Good morning",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Here's what's happening in your account today.",
  annonces_en_ligne: "Online ads",
  nouveaux_messages: "New posts",
  prochains__changes: "Next exchanges",
  matching_section__o__je_veux_aller: "Matching section: Where I want to go",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Add up to 10 cities with radius in km and your departure dates to receive more targeted proposals.",
  configurer_mes_pr_f_rences: "Configure my preferences",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Ready to welcome your first travelers?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Complete your profile and post your first ad to start exchanging your accommodation with the TravelExchange community.",
  cr_er_mon_annonce: "Create my ad",
  compl_ter_mon_profil: "Complete my profile",
  impossible_de_charger_vos_preferences_: "Unable to load your preferences.",
  preferences_enregistrees_: "Saved preferences.",
  impossible_d_enregistrer_vos_preferences_: "Unable to save your preferences.",
  impossible_de_supprimer_votre_profil_: "Unable to delete your profile.",
  chargement_des_preferences___: "Loading preferences...",
  unites_de_distance: "Distance units",
  kilom_tres__km_: "Kilometers (km)",
  format_europeen_par_defaut: "Default European format",
  miles__mi_: "Miles (mi)",
  format_anglo_saxon: "Anglo-Saxon format",
  visibilite_du_profil: "Profile Visibility",
  mettre_mon_profil_en_pause: "Pause my profile",
  me_masquer_dans_les_resultats_de_recherche: "Hide me from search results",
  zone_sensible: "Sensitive area",
  suppression___: "Deletion...",
  supprimer_mon_profil: "Delete my profile",
  pensez_a_enregistrer_vos_modifications_: "Remember to save your changes.",
  enregistrement___: "Registration...",
  enregistrer_les_preferences: "Save preferences",
  impossible_de_charger_votre_profil_: "Unable to load your profile.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Profile partially saved. The database must be updated (SQL migration).",
  profil_mis___jour_avec_succ_s_: "Profile updated successfully.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Profile not saved: database needs to be migrated (missing columns).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Profile not saved: too many columns missing. Start SQL migration.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Your database is not up to date. Run the SQL migration and try again.",
  erreur_lors_de_la_mise___jour_: "Error during update.",
  photo_de_profil_mise___jour_: "Updated profile photo.",
  erreur_upload_photo_: "Photo upload error.",
  photo_de_couverture_mise___jour_: "Updated cover photo.",
  erreur_upload_couverture_: "Cover upload error.",
  document_envoy__pour_v_rification_: "Document sent for verification.",
  erreur_lors_de_l_envoi_du_document_: "Error sending document.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Unable to load your profile at this time.",
  mon_profil_h_te: "My host profile",
  identit___r_seaux_et_infos_de_matching:
    "Identity, networks and matching information",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "The more complete your profile is, the more compatible hosts the engine can suggest.",
  compl_tude_du_profil: "Profile completeness",
  couverture: "Blanket",
  photo_principale: "Main photo",
  h_te_traveltrok: "Host DONKEY TRAVEL",
  localisation_non_renseign_e: "Location not provided",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Add a large photo to better present your host world.",
  destinations_cibl_es: "Targeted destinations",
  dates_pr_vues: "Planned dates",
  configurer___o__je_veux_aller__: "Configure “Where I want to go”",
  statut_identit_: "Identity status",
  v_rifi_: "Verified",
  en_cours: "In progress",
  non_v_rifi_: "Not verified",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Add ID to build community trust.",
  envoyer_document: "Send document",
  identit__et_contact: "Identity and contact",
  pr_nom: "First name",
  nom: "Name",
  pseudo_public: "Public nickname",
  email: "E-mail",
  t_l_phone: "Phone",
  r_seaux_et_liens: "Networks and links",
  site_web: "Website",
  localisation_et_mode_de_voyage: "Location and mode of travel",
  pays_de_r_sidence: "Country of Residence",
  s_lectionnez_un_pays: "Select a country",
  ville_de_r_sidence: "City of residence",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "How many people are traveling?",
  voyagez_vous_avec_des_animaux__: "Do you travel with animals?",
  oui: "Yes",
  non: "No",
  voyagez_vous_avec_des_b_b_s__: "Are you traveling with babies?",
  bio_h_te: "Host bio",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Present your hospitality style and your accommodation.",
  pr_sentation_de_la_famille: "Presentation of the family",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Who is traveling, habits, pace, type of stay sought...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Also complete “Where I want to go” to activate more precise matching.",
  enregistrer_le_profil: "Save profile",
  horizon_contrat: "Contract horizon",
  "24_mois_apres_le_1er_sejour": "24 months after the first stay",
  nuits_que_je_dois: "Nights that I owe",
  nuits_qu_on_me_doit: "Nights that I owe",
  echanges_ouverts: "Open exchanges",
  echanges_proches_echeance: "Trades near maturity",
  alerte_solde_des_echanges: "Exchange balance alert",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "No risk profile detected at the moment.",
  contrats_en_cours: "Current contracts",
  personne: "Person",
  logement: "Accommodation",
  contrat: "CONTRACT",
  dates: "Dates",
  echange_effectue: "Exchange made",
  solde_nuits: "Sale nights",
  temps_restant: "Time remaining",
  "1er_sejour_": "1st stay:",
  echeance_: "Due date:",
  ils_sont_venus__fait: "They came: done",
  ils_sont_venus__en_attente: "They came: waiting",
  je_suis_alle__fait: "I went: done",
  je_suis_alle__en_attente: "I went: waiting",
  je_dois: "I have to",
  nuits: "nights",
  on_me_doit: "I am owed",
  carte_des_p_rim_tres_de_recherche: "Map of research areas",
  villes_localis_es: "localized towns",
  mise___jour_de_la_carte___: "Updating the map...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "You must be logged in to manage your preferences.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Unable to load your matching preferences at this time.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Add at least one target city to activate matching.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "A period has an end date before the start date.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Select at least one country if you enable the contact filter by country.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Saved preferences. Targeted countries are kept locally until SQL migration is applied.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Matching preferences saved successfully.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Preferences not saved: database not migrated. Start SQL migration.",
  erreur_lors_de_l_enregistrement_: "Error saving.",
  matching_intelligent: "Smart matching",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Indicate your target cities and your departure periods: DONKEY TRAVEL will be able to offer the most compatible hosts.",
  retour_au_profil: "Back to profile",
  villes_et_rayon_de_recherche: "Cities and search radius",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Up to 10 cities (eg: Amiens 2 km, Paris 5 km, Lille 20 km).",
  villes_actives: "active cities",
  ville: "City",
  choisir_un_pays: "Choose a country",
  saisissez_une_ville: "Enter a city",
  choisissez_le_pays_d_abord: "Choose the country first",
  rayon: "Radius",
  supprimer_cette_ville: "Delete this city",
  ajouter_une_ville: "Add a city",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "These cities will be used to offer targeted exchanges.",
  enregistrer_mes_pr_f_rences: "Save my preferences",
  pays_d_europe___visiter: "European countries to visit",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Check the countries that interest you. You can then limit contacts to these countries.",
  pays_s_lectionn_s: "selected countries",
  tout_cocher: "Check all",
  tout_d_cocher: "Uncheck all",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Be contacted only by members from these countries",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "This filter will be used in your automatic matching.",
  union_europ_enne: "European Union",
  hors_union_europ_enne: "Outside the European Union",
  agenda_des_d_parts_souhait_s: "Schedule of desired departures",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Add the periods when you want to leave to start matching on common slots.",
  p_riode_s__active_s_: "active period(s)",
  aucune_p_riode_ajout_e_pour_le_moment_: "No periods added yet.",
  p_riode: "Period",
  supprimer_cette_p_riode: "Delete this period",
  d_part: "Departure",
  commentaire__optionnel_: "Comment (optional)",
  ajouter_une_p_riode: "Add a period",
  r_sum__matching: "Summary matching",
  villes_cibles: "Target cities",
  rayon_moyen: "Average radius",
  p_riodes_planifi_es: "Planned periods",
  pays_cibl_s: "Targeted countries",
  contacts_limit_s_aux_pays_coch_s: "Contacts limited to checked countries",
  contacts_ouverts___tous_les_pays: "Contacts open to all countries",
  agenda_aper_u: "Agenda overview",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Add a period to display your departure calendar.",
  sans_commentaire: "No comment",
  logement_traveltrok: "DONKEY TRAVEL accommodation",
  localisation_a_preciser: "Location to be specified",
  logements_trouves: "accommodation found",
  plus_recents: "Most recent",
  capacite_max: "Max capacity",
  h_tes: "Hosts",
  villes: "Cities",
  logements_disponibles: "Accommodations available",
  pays_disponibles: "Countries available",
  marie_accepte__: "Marie accepts!",
  nuits_a_reims_contre: "nights in Reims against",
  nuits_a_paris: "nights in Paris",
  l_histoire_de_marie_jean: "The story of Marie & Jean",
  "1__marie_consulte_l_agenda_de_jean": "1. Marie consults Jean’s diary",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "She sees that Jean has free dates in 2 weeks. Perfect for her! Jean confirms that he can release these dates.",
  h_tes_actifs: "Active hosts",
  pays_couverts: "Countries covered",
  echanges_realises: "Exchanges made",
  "100__match": "100% Match",
  echanges_longue_distance: "Long distance exchanges",
  matching_algorithmique_intelligent: "Intelligent algorithmic matching",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Our algorithm crosses the information from your profile and your searches to offer you all the housing advertisements that correspond exactly to your request.",
  matching_precis: "Precise matching",
  analyse_intelligente_de_vos_crit_res: "Intelligent analysis of your criteria",
  gain_de_temps_dans_vos_recherches: "Save time in your research",
  propositions_ultra_pertinentes: "Ultra-relevant proposals",
  habitants: "residents",
  destinations_europeennes: "European Destinations",
  decouvrez_les_merveilles_du_continent:
    "Discover the wonders of the continent",
  pays_actifs_sur_traveltrok: "Countries active on DONKEY TRAVEL",
  selectionner_un_pays: "Select a country",
  union_europeenne: "European Union",
  hors_union_europeenne: "Outside the European Union",
  fiche_detaillee: "Detailed sheet",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Select a country from the list or on the map to discover climate, population and emblematic places.",
  logements_actifs: "active housing",
  climat: "Climate",
  information_touristique: "Tourist Information",
  lieux_emblematiques: "Iconic places",
  gastronomie: "Gastronomy",
  dom_tom___outre_mer: "DOM-TOM / Overseas",
  villes_principales: "Main cities",
  charte_officielle: "Official charter",
  confiance_mutuelle: "Mutual trust",
  r_gles_claires: "Clear rules",
  sanctions_applicables: "Applicable sanctions",
  illustration_3d_des_engagements: "3D illustration of commitments",
  concept_3d_informations: "3D image of details",
  principe_1: "Principle 1",
  v_racit__des_informations: "Veracity of information",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Profile, accommodation, photos and prices must be accurate.",
  concept_3d_respect_du_lieu: "3D image of respect for the place",
  principe_2: "Principle 2",
  respect_du_lieu: "Respect for the place",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "No parties and zero nuisance to the neighborhood.",
  concept_3d_fiabilit__contractuelle: "Contract concept in 3D",
  principe_3: "Principle 3",
  fiabilit__contractuelle: "Contractual reliability",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Blocked dates = firm commitment, unless there is a valid reason.",
  engagements_c_t__voyageur: "Commitments on the passenger side",
  engagements_c_t__h_te: "Host-side commitments",
  annulations_et_reports: "Cancellations and postponements",
  r_gle_op_rationnelle: "Operational rule",
  check_list_d_part_voyageur: "Departure checklist",
  cuisine_et_vaisselle_propres: "Clean kitchen and dishes",
  sols_et_surfaces_rendus_propres: "Floors and surfaces made clean",
  linge_utilis__d_pos__selon_consigne:
    "Used linen deposited according to instructions",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "No unauthorized invitations",
  _tat_final_du_logement_confirm__avec_photos:
    "Final condition of housing confirmed",
  sanctions_en_cas_de_manquement: "Sanctions in the event of non-compliance",
  ce_que_permet_traveltrok: "What DONKEY TRAVEL allows",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "You can list as many accommodations as you want.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Exchange without recurrence limit during the year.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "A formal contract officially binds hosts and guarantees success.",
  r_f_rences_de_bonnes_pratiques: "Best practice references",
  un_club_s_rieux__une_communaut__durable:
    "A serious club creates a lasting community",
  retour_au_guide_complet: "Back to full guide",
  carte_des_logements_traveltrok: "DONKEY TRAVEL accommodation map",
  points_logements: "Accommodation points",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "No geolocated data at the moment.",
  envie_d_entrer_dans_la_carte__: "Want to get on the map?",
  chargement_des_logements___: "Loading housing...",
  la_date_d_arriv_e_est_requise: "Arrival date is required",
  la_date_ne_peut_pas__tre_dans_le_pass_: "The date cannot be in the past",
  la_date_de_d_part_est_requise: "Departure date is required",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "Departure date must be after arrival",
  le_message_doit_contenir_au_moins_10_caract_res:
    "The message must contain at least 10 characters",
  veuillez_corriger_les_erreurs_ci_dessus: "Please correct the errors above",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "An error has occurred. Please try again.",
  paris__france: "Paris, France",
  mode_h_te: "Host mode",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "I rent a few weeks a year. The 1EUR/night model is super simple to explain to travelers.",
  "37_nuits": "37 nights",
  lyon__france: "Lyon, France",
  mode_voyageur: "Traveler fashion",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "The reservation is smooth, and above all the fees are legible. I easily compare the final cost before confirming.",
  "22_nuits": "22 nights",
  bordeaux__france: "Bordeaux, France",
  "54_nuits": "54 nights",
  marseille__france: "Marseille, France",
  pro_multi_logements: "Pro multi-dwelling",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "With multiple properties, the Pro version saves me a lot of time on scheduling and managing requests.",
  "9_logements": "9 accommodations",
  retours_utilisateurs: "User feedback",
  des_retours_terrain_concrets: "Concrete field feedback",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Travelers and hosts who want a clearer and more affordable rental.",
  activit_: "activity",
  _conomie_estim_e: "estimated savings",
  profils_et_logements_v_rifi_s: "Verified profiles and accommodations",
  exp_rience_location_simplifi_e: "Simplified rental experience",
  co_ts_transparents___la_nuit: "Transparent costs at night",
  marquer_des_dates: "Mark dates",
  je_peux_accueillir: "I can accommodate",
  je_veux_partir: "I want to leave",
  partir_et_accueillir: "Depart and Welcome",
  accueillir: "To welcome",
  partir: "Leave",
  bloquer_les_dates: "Block dates",
  toujours_partir_et_accueillir: "Always Leave and Welcome",
  rendre_ce_logement_visible: "Make this accommodation visible",
  rendre_ce_logement_invisible: "Make this accommodation invisible",
  confirmation_visibilite_logement:
    "Are you sure you want to change the visibility of THIS listing for other members?",
  confirmer_activer_toujours_partir_accueillir:
    "By activating this mode, new 'Leave and Welcome' availabilities will be added to always cover the next 2 years from today. Other manual availabilities will be overwritten.\n\nAre you sure you want to continue?",
  confirmer_desactiver_toujours_partir_accueillir:
    "Are you sure you want to turn off 'Always Leave and Greet' mode?",
  details_de_l_adresse__optionnel_: "Address details (optional)",
  rue_et_numero: "Street and number",
  ex__12_rue_de_la_paix: "Ex: 12 rue de la Paix",
  appartement_suite: "Apartment, suite, etc.",
  ex__apt_4b: "Ex: Apt 4B",
  etage: "Floor",
  ex__3eme_sans_ascenseur: "Ex: 3rd",
  code_d_acces: "Access code (door/building)",
  ex__a1234: "Ex: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "This detailed information will only be communicated to members who have a confirmed exchange with you.",
  lits_doubles: "Double beds",
  lits_simples: "Single beds",
  canapes_lits: "Sofa beds",
  lits_bebes: "Baby beds",
  amenity_cat_essentials: "The essentials",
  amenity_cat_kitchen: "Cooking and meals",
  amenity_cat_bathroom: "Bathroom",
  amenity_cat_bedroom_laundry: "Bedroom and linen",
  amenity_cat_entertainment: "Entertainment",
  amenity_cat_family: "Family",
  amenity_cat_exterior: "Outside",
  amenity_cat_features: "Features",
  amenity_cat_location: "Location",
  amenity_cat_safety: "Security",
  amenity_wifi: "Wi-Fi",
  amenity_workspace: "Dedicated workspace",
  amenity_ac: "Air conditioning",
  amenity_heating: "Heating",
  amenity_kitchen: "Kitchen",
  amenity_refrigerator: "Fridge",
  amenity_microwave: "Microwave",
  amenity_oven: "Oven",
  amenity_dishwasher: "Dishwasher",
  amenity_coffee_maker: "Coffee machine",
  amenity_kettle: "Kettle",
  amenity_bathtub: "Bathtub",
  amenity_hair_dryer: "hair dryer",
  amenity_shampoo: "Shampoo and shower gel",
  amenity_hot_water: "Hot water",
  amenity_washing_machine: "Washing machine",
  amenity_dryer: "Dryer",
  amenity_iron: "Iron",
  amenity_hangers: "Hangers",
  amenity_bed_linens: "Bed linen provided",
  amenity_tv: "Television",
  amenity_game_console: "Game console",
  amenity_books_toys: "Books and toys",
  amenity_sound_system: "Audio system",
  amenity_high_chair: "High chair",
  amenity_baby_bath: "Baby bath",
  amenity_travel_cot: "Travel cot",
  amenity_changing_table: "Changing table",
  amenity_patio: "Balcony or terrace",
  amenity_garden: "Private garden",
  amenity_bbq: "Barbecue",
  amenity_outdoor_furniture: "Outdoor furniture",
  amenity_pool: "Pool",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Gym",
  amenity_fireplace: "Chimney",
  amenity_breakfast: "Breakfast included",
  amenity_parking: "Free parking",
  amenity_ev_charger: "EV charging station",
  amenity_beachfront: "Beach access",
  amenity_ski_in_out: "Access to the ski slopes",
  amenity_lake_access: "Lake access",
  amenity_smoke_detector: "Smoke detector",
  amenity_first_aid: "First aid kit",
  amenity_fire_extinguisher: "Extinguisher",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Massage chair",
  amenity_shower: "Shower",
  amenity_home_cinema: "Home Cinema",
  amenity_ping_pong: "Ping pong table",
  amenity_forest_access: "Access to the forest",
  amenity_hiking_access: "Access to hiking",
  compl_t_: "completed",
  l_adresse_doit_tre_localis_e_sur_la_carte:
    "The address must be located on the map",
  au_moins_3_photos_requises: "At least 3 photos are required",
  le_titre_doit_faire_au_moins_10_caract_res:
    "The title must be at least 10 characters long",
  la_description_doit_faire_au_moins_50_caract:
    "The description must be at least 50 characters long",
  s_lectionnez_au_moins_3_quipements: "Select at least 3 equipment",
  encore_quelques_d_tails_avant_de_publier:
    "A few more details before publishing",
  votre_annonce_est_compl_t_e_x:
    "Your ad is completed at {{score}}%. Please fill in the missing elements to be able to publish it:",
  compl_ter: "Complete",
  voici_comment_les_voyageurs_verront_votre_:
    "This is how travelers will see your listing.",
  photo: "Photo",
  afficher_toutes_les_photos: "Show all photos",
  h_t_par_vous: "• Host: You",
  description: "About this accommodation",
  votre_description_appara_tra_ici: "Your description will appear here...",
  afficher_les_n__quipements_x: "Show them{{count}}equipment",
  ajouter_une_date: "Add a date",
  aucun_montant_ne_vous_sera_d_bit_:
    "No amount will be charged to you at this time",
  demander: "Ask",
  enregistrer_et_quitter: "Save and exit",
  enregistrer_pour_plus_tard: "Save for later",
  conseils_pour_des_photos_r_ussies: "Tips for successful photos",
  privil_giez_le_format_paysage__1:
    "Choose landscape format (16:9) for better display.",
  prenez_vos_photos_de_jour__avec_:
    "Take your photos during the day, with good natural light.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Store and clean the pieces before photographing them.",
  mettez_en_avant_les_atouts_de_vo:
    "Highlight the assets of your accommodation (view, terrace, beautiful living room, etc.).",
  donnez_un_titre___votre_annonce: "Give your ad a title",
  un_titre_court_et_accrocheur_attirera_pl:
    "A short and catchy title will attract more travelers.",
  souhaite_visiter: "Would like to visit",
  vous_propose_en_change: "Offers you in exchange",
  autres_logements: "other accommodation",
  voir_le_logement: "See the accommodation",
  votre_demande_titre: "Your request",
  votre_demande_soustitre:
    "Summary of your travel desires and companions for your future exchanges.",
  compagnons_de_voyage: "Travel companions",
  voyage_avec_bebe: "Babies)",
  voyage_avec_animaux: "Pets",
  disponibilites_souhaitees: "Desired availability",
  destinations_cibles: "Target destinations",
  aucune_date_precisee: "No travel date has been specified.",
  aucune_destination_precisee: "No target destination has been specified.",
  votre_demande_menu: "Your request",
  modifier_mon_profil: "Edit my profile",
  rayon_de: "Radius of{{km}}km",
  dates_flexibles_option: "Flexible dates",
  animaux_de_compagnie_details: "{{count}}animal/animals",
  changer_d_annonce: "Change ad",
  profil_du_voyageur: "Traveler profile",
  chambres_requises: "Required rooms",
  animaux: "animal(s)",
  duree_du_sejour_souhaitee: "Desired length of stay",
  combien_de_chambres_avez_vous_besoin__: "How many bedrooms do you need?",
  combien_de_b_b_s__: "How many babies?",
  combien__: "How much ?",
  vos_animaux: "Your animals",
  chien_s_: "Dog(s)",
  plus_de_30_nuits: "More than 30 nights",
  "community.hero.badge": "Our Community",
  "community.hero.title": "Join the most authentic host network",
  "community.hero.subtitle":
    "Share more than just your home. Discover stories, meet passionate hosts and travel with confidence.",
  "community.stats.members": "Active Members",
  "community.stats.countries": "Countries Represented",
  "community.stats.exchanges": "Exchanges Made",
  "community.values.title": "What brings us together",
  "community.values.trust.title": "Absolute Confidence",
  "community.values.trust.desc":
    "Each member is a verified host, guaranteeing mutual respect for the premises.",
  "community.values.sharing.title": "Sharing & Meetings",
  "community.values.sharing.desc":
    "The opportunity to create links with locals all over Europe.",
  "community.values.savings.title": "Real Savings",
  "community.values.savings.desc":
    "Travel more often, further, while preserving your budget.",
  "community.testimonials.title": "Member Stories",
  "community.cta.title": "Ready to be part of the adventure?",
  "community.cta.button": "Become a member today",
  "blog.hero.badge": "Our Blog",
  "blog.hero.title": "Inspiration & Tips",
  "blog.hero.subtitle":
    "Discover travel stories, tips for preparing your accommodation and what's new at the club.",
  "blog.categories.all": "All articles",
  "blog.categories.tips": "Host Tips",
  "blog.categories.inspiration": "Travel inspiration",
  "blog.categories.news": "News",
  "blog.empty": "No articles at the moment. Come back soon!",
  "help.hero.badge": "Help Center",
  "help.hero.title": "How can we help you?",
  "help.hero.subtitle": "Find quick answers or contact our support team.",
  "help.search.placeholder": "Search for an answer...",
  "help.categories.account.title": "Account & Profile",
  "help.categories.account.desc":
    "Manage your information, passwords and preferences.",
  "help.categories.exchanges.title": "Exchanges & Reservations",
  "help.categories.exchanges.desc":
    "How to offer, accept or cancel an exchange.",
  "help.categories.trust.title": "Trust & Security",
  "help.categories.trust.desc":
    "Contracts, verification and protection of housing.",
  "help.faq.title": "Frequently Asked Questions",
  "help.contact.cta": "Didn't find your answer?",
  "help.contact.button": "Contact us",
  "careers.hero.badge": "Join the team",
  "careers.hero.title": "Let's build the future of travel",
  "careers.hero.subtitle":
    "We're looking for passionate people to redefine the way guests travel in Europe.",
  "careers.values.title": "Our Values",
  "careers.values.trust.title": "Human and Trust",
  "careers.values.remote.title": "Flex teleworking",
  "careers.values.impact.title": "Real Impact",
  "careers.openings.title": "Open Positions",
  "careers.openings.empty":
    "No positions currently open. Don't hesitate to send a spontaneous application!",
  "careers.apply.title": "Spontaneous Application",
  "careers.apply.desc":
    "Send your CV and tell us how you can help Donkey Travel.",
  "careers.apply.button": "Send my application",
  "contact.hero.badge": "Contact",
  "contact.hero.title": "We are here for you",
  "contact.hero.subtitle":
    "A question, suggestion or problem? Our team is ready to listen to you.",
  "contact.form.name": "Your name",
  "contact.form.email": "Your email",
  "contact.form.subject": "Subject of your message",
  "contact.form.message": "Your message...",
  "contact.form.send": "Send message",
  "contact.info.title": "Useful Information",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Haute-Somme Valley, Picardy, France",
  "contact.info.hours": "Mon - Fri: 9:00 a.m. - 6:00 p.m.",
  activez_votre_abonnement: "Activate your subscription",
  finalisez_votre_inscription: "Finalize your registration",
  _changes_illimit_s_en_europe: "Unlimited exchanges in Europe",
  validit___1_an: "Validity: 1 year",
  paiement_100__s_curis__par_paypal: "100% secure payment by PayPal",
  me_d_connecter_et_revenir_plus_tard: "Log out and come back later",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Error validating payment on our servers.",
  le_paiement_n_a_pas_pu__tre_valid_: "The payment could not be validated.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "An unknown error occurred during payment.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Unable to initialize PayPal. Check your connection.",
  donn_es_personnelles: "Personal data",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Join our community and book accommodation in {{city}} with clear fixed fees and insurance included.",
  bienvenue: "Welcome",
  code_promo_applique_avec_succes: "Promo code applied successfully!",
  cible: "Target",
  propose: "Propose",
  "1_sens": "1 sense",
  "2_sens": "2 senses",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "They want to visit your area.<br />It's up to you to find out where they live!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "They are looking for you AND<br />they live where you want to go!",
  comment_ca_marche: "How does it work?",
  comprendre_les_differents_types_de_matching:
    "Understanding the different types of matching",
  match_reciproque: "Reciprocal match",
  details_de_la_demande: "Request details",
  souhaite_venir_dans_votre_secteur: "Would like to come to your area:",
  peut_vous_accueillir: "Can accommodate you:",
  souhaite_visiter_dans_un_rayon:
    "Would like to visit <strong>{{city}}</strong> within a radius of <strong>{{radius}} km</strong>, your accommodation matches their search.",
  souhaite_visiter_ville:
    "Would like to visit <strong>{{city}}</strong>, your accommodation matches their search.",
  a_besoin_de_chambres: "Needs {{count}} room(s).",
  comparateur_de_valeur: "Value comparator",
  ecart: "gap",
  code_promo_invalide: "Invalid promo code",
  erreur_verification_code: "Error verifying code",
  vous_avez_un_code_promo: "Do you have a promo code?",
  entrez_votre_code: "ENTER YOUR CODE",
  appliquer: "Apply",
  importation_r_ussie_:
    "Import successful! Your information has been pre-filled.",
  erreur_lors_de_l_importation: "Error during import:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Describe what makes your home unique...",
  mettez_en_avant_les_points_forts___votre:
    "Highlight the strong points of your accommodation",
  lien_annonce_airbnb_1: "Link to your Airbnb listing",
  importation___: "Import...",
  importer_l_annonce: "Import ad",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Enter the link to your ad. You can import the details automatically to save time.",
  lien_calendrier_airbnb: "Calendar link (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "We will use this link to synchronize your availability.",
  entrer_en_contact: "Get in touch",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Warning: high risk of addiction to free travel!",
};
